import { render, staticRenderFns } from "./wtTextField.component.vue?vue&type=template&id=56115ce5&"
import script from "./wtTextField.component.vue?vue&type=script&lang=js&"
export * from "./wtTextField.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports